import { connect } from 'react-redux';
import ListadoInventario from "./Listado";
import { actions } from "../../../../redux/modules/inventario/inventario"

const ms2p = (state) => {
    return {
        ...state.inventario,
        conf_tipo_ajuste_inventario:
        state.usuario.me
            ? state.usuario.me.conf_tipo_ajuste_inventario
            : false,
        print_state: state.print,
        config: state.configuracion.config,
        conf_tipo_negocio:
        state.configuracion && state.configuracion.config
            ? state.configuracion.config.conf_tipo_negocio
            : false,
    }
}

const md2p = {...actions};

export default connect(ms2p, md2p)(ListadoInventario);
